import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import "./Login.css";

function Login() {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      const response = await instance.loginPopup(loginRequest);
      if (response && response.account) {
        instance.setActiveAccount(response.account);
      }
    } catch (error) {
      console.error("Login popup failed, redirecting:", error);
      instance.loginRedirect(loginRequest);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
          <div className="login-header">
          <img src="/01_Socialit_marchio_RGB_colorato%20%2B%20bianco.png" alt="Socialit" className="login-logo-image"  />
          <h1>Customer Service Portal</h1>
        </div>

        <div className="login-content">
          <p className="login-description">
            Accedi al Customer Service Portal.
          </p>

          <button onClick={handleLogin} className="btn-login">
            <span className="btn-icon">🔐</span>
            Accedi con Microsoft
          </button>

          <div className="login-info">
            <p>
              Usa le tue credenziali aziendali per accedere al Customer Service Portal di Socialit.
            </p>
          </div>
        </div>

        <div className="login-footer">
          <p>&copy; 2026 Socialit. Tutti i diritti riservati.</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
